// extracted by mini-css-extract-plugin
module.exports = {"base":"Omnibar_base__REqO6","backdrop":"Omnibar_backdrop__3v_16","bar":"Omnibar_bar__3ta0m"};